import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import {
  HaynesProVesaComponentModel,
  HaynesProVesaNetworkModel,
  HaynesProVesaSignalInstanceModel,
  HaynesProVesaSignalModel
} from '../typings/haynes-pro.vesa';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-vesa-networks',
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-networks.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-networks.component.html')
})
export class HaynesProDiagnosticToolVesaNetworksComponent {

  @Input() networks : Array<HaynesProVesaNetworkModel>;

  @Output() componentSelect = new EventEmitter<{ component : HaynesProVesaComponentModel; systemTypeId : string }>();

  expandedSignals : Set<string> = new Set();

  getSignalKey ( network : HaynesProVesaNetworkModel, direction : string, signal : HaynesProVesaSignalModel ) : string {
    return `${network.system_type_id}_${direction}_${signal.signal_id}`;
  }

  handleInstanceClick ( instance : HaynesProVesaSignalInstanceModel, network : HaynesProVesaNetworkModel, event : MouseEvent ) : void {
    event.stopPropagation();
    this.emitInstanceSelect(instance, network);
  }

  handleSignalClick ( network : HaynesProVesaNetworkModel, signal : HaynesProVesaSignalModel, direction : string ) : void {
    if (signal.instances?.length > 1) {
      const key = this.getSignalKey(network, direction, signal);

      if (this.expandedSignals.has(key)) {
        this.expandedSignals.delete(key);
      } else {
        this.expandedSignals.add(key);
      }

      return;
    }

    if (signal.instances?.length === 1) {
      this.emitInstanceSelect(signal.instances[0], network);
    }
  }

  isActive ( signal : HaynesProVesaSignalModel, network : HaynesProVesaNetworkModel ) : boolean {
    return signal.system_groups?.includes(network.system_group_ids);
  }

  isExpandable ( signal : HaynesProVesaSignalModel ) : boolean {
    return signal.instances?.length > 1;
  }

  isExpanded ( network : HaynesProVesaNetworkModel, direction : string, signal : HaynesProVesaSignalModel ) : boolean {
    return this.expandedSignals.has(this.getSignalKey(network, direction, signal));
  }

  private emitInstanceSelect ( instance : HaynesProVesaSignalInstanceModel, network : HaynesProVesaNetworkModel ) : void {
    if (!instance?.component_id || !network?.system_type_id) {
      return;
    }

    this.componentSelect.emit({
      component: {
        id  : instance.component_id,
        name: instance.text,
        type: ''
      },
      systemTypeId: network.system_type_id
    });
  }
}
